import { Link } from "react-router-dom";
import TextInput from "../UI/TextInput";
import {Button, Grid, Typography} from "@mui/material";
import {useSelector} from "react-redux";
import {TYPE_CCATS} from "../../store/account/constants";
import PhoneInput from "../UI/PhoneInput";

const SignUpForm = ({ form, errors, onChange, redirectPath = "/" }) => {
  const signinLink = `${redirectPath}signin`;
  const programType = useSelector((state) => state.account.programType);

    function handlePhoneChange(name, value) {
        onChange({ target: { name, value } });
    }

  return (
    <>
        <Grid container direction="row" spacing={2}>
        <Grid item xs={12}>
        <Typography variant="h5" align="left">
        Create a Parent Account
      </Typography>
        </Grid>
        <Grid item xs={12}>
      <Typography variant="caption">
          To register {programType === TYPE_CCATS ? "students" : "children"} for {programType === TYPE_CCATS ? "C-CATS" : "summer camp"}, please create an account.
      </Typography>
        </Grid>
            <Grid item xs={6}>
                <TextInput
                    type="text"
                    name="firstName"
                    label="First Name"
                    value={form.firstName}
                    onChange={onChange}
                    error={errors.firstName}
                />
            </Grid>
            <Grid item xs={6}>
                <TextInput
                    type="text"
                    name="lastName"
                    label="Last Name"
                    value={form.lastName}
                    onChange={onChange}
                    error={errors.lastName}
                />
            </Grid>
        <Grid item xs={12}>
        <PhoneInput
            name="phone"
            label="Phone Number"
            value={form.phone}
            onChange={(value) => handlePhoneChange("phone", value)}
            error={errors.phone}
        />
        </Grid>
        <Grid item xs={12}>
          <TextInput
            type="text"
            name="email"
            label="Email"
            value={form.email}
            onChange={onChange}
            error={errors.email}
            autoComplete="email"
          />
        </Grid>
        <Grid item xs={12}>
      <TextInput
        type="text"
        name="confirmEmail"
        label="Confirm Email"
        value={form.confirmEmail}
        onChange={onChange}
        error={errors.confirmEmail}
        autoComplete="email"
      />
        </Grid>
        <Grid item xs={12}>
      <TextInput
        type="password"
        name="password"
        label="Password"
        value={form.password}
        onChange={onChange}
        error={errors.password}
        autoComplete="new-password"
      />
        </Grid>
        <Grid item xs={12}>
      <TextInput
        type="password"
        name="confirmPassword"
        label="Confirm Password"
        value={form.confirmPassword}
        onChange={onChange}
        error={errors.confirmPassword}
        autoComplete="new-password"
      />
        </Grid>
        <Grid item xs={12}>
          <Typography variant="body2">
            Already have an account? <Link to={signinLink}>Sign in</Link>
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Button
              type="submit"
              variant="contained"
              sx={{ height: "55px" }}
              fullWidth>
            Create Account
          </Button>
        </Grid>
        </Grid>
    </>
  );
};

export default SignUpForm;
